<template>
  <div class="container row">
    <table class="table table-borderless">
      <tbody class="body">
        <tr>
          <td class="col-6 head">Transfer Batch No.</td>
          <td class="col-6 head">Transfer Date</td>
        </tr>
        <tr>
          <td
            v-if="!transferStore.currentTransfer?.batchNumber"
            class="content"
          >
            -
          </td>
          <td v-else class="content">
            {{ transferStore.currentTransfer?.batchNumber }}
          </td>
          <td class="content">
            {{
              $filters.formatDate(transferStore.currentTransfer?.transferDate)
            }}
          </td>
        </tr>
        <tr>
          <td class="head">SIP Name</td>
          <td class="head">Transferring Agency</td>
        </tr>
        <tr>
          <td v-if="!transferStore.currentSip?.name" class="content">-</td>
          <td v-else class="content">
            {{ transferStore.currentSip?.name }}
          </td>
          <td v-if="!transferStore.currentSip?.name" class="content">-</td>
          <td v-else class="content">
            {{ transferStore.currentTransfer?.transferringAgency }}
          </td>
        </tr>
        <tr>
          <td class="head">No. of Files</td>
          <td class="head">Size</td>
        </tr>
        <tr>
          <td v-if="!transferStore.currentSip?.name" class="content">-</td>
          <td v-else class="content">
            {{ transferStore.currentSip?.fileCount }}
          </td>
          <td v-if="!transferStore.currentSip?.name" class="content">-</td>
          <td v-else class="content">
            {{ $filters.formatSizeUnits(transferStore.currentSip?.totalSize) }}
          </td>
        </tr>
        <tr>
          <td class="head">Security Grading</td>
          <td class="head">Sensitivity Classification</td>
        </tr>
        <tr>
          <td v-if="!transferStore.currentSip?.name" class="content">-</td>
          <td v-else class="content">
            {{ transferStore.currentSip?.highestSecurityGrading }}
          </td>
          <td v-if="!transferStore.currentSip?.name" class="content">-</td>
          <td v-else class="content">
            {{ transferStore.currentSip?.highestSensitivityClassification }}
          </td>
        </tr>
        <tr>
          <td class="head">SIP UUID</td>
          <td class="head"></td>
        </tr>
        <tr>
          <td v-if="!transferStore.currentSip?.name" class="content">-</td>
          <td v-else class="content">
            {{ transferStore.currentSip?.sipId }}
          </td>
          <td class="content"></td>
        </tr>
      </tbody>
      <tbody class="body" v-show="transferStore.currentTransfer?.note">
        <tr>
          <td class="head">Batch Note</td>
          <td></td>
        </tr>
        <tr>
          <td class="content">{{ transferStore.currentTransfer?.note }}</td>
          <td></td>
        </tr>
        <tr>
          <td class="head">Batch Note Added By</td>
          <td class="head">Date and Time of Batch Note</td>
        </tr>
        <tr>
          <td class="content">
            {{ transferStore.currentTransfer?.noteCreatedBy }}
          </td>
          <td class="content">
            {{
              $filters.formatDateAndTime(
                transferStore.currentTransfer?.noteCreatedAt
              )
            }}
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <span class="row border-top" v-show="transferStore.currentTransfer.status == 'SIP Processing Failed' && (transferStore.currentSip?.status == 'Ingest Failed' || transferStore.currentSip?.status == 'Storage Failed')">
      <button class="col btn btn-outline-secondary" 
        data-bs-toggle="modal"
        data-bs-target="#resubmitSipModal"
        style="margin-left: 10px; margin-top: 10px"
        @click="changeStyle">
        Resubmit SIP
      </button>
    </span> -->
  </div>
  <!-- <reprocess-resubmit-transfer-modal :sip-id="props.sipId"/> -->
  <reprocess-resubmit-transfer-modal />
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
// import GlobalData from "@/GlobalData";
import { useTransferStore } from "@/stores/content_review/transfer";
import { useAsyncState } from "@vueuse/core";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import ReprocessResubmitTransferModal from "@/components/Modal/ReprocessResubmitTransferModal.vue"

const router = useRouter();
const transferStore: any = useTransferStore();

onMounted(() => execute())

// onMounted(() => {
//   let resumitSipModal: any = document.getElementById("resubmitSipModal") ;
//   resumitSipModal.addEventListener("hidden.bs.modal", function () {
//     GlobalData.getInstance().changeSipPosition(
//       "batch-layout",
//       "border-start"
//     );
//   });
//   execute();
// });

// const props = defineProps({
//   sipId: { type: String, required: true },
// });

const { execute, error } = useAsyncState(() => {
  return transferStore.fetchTransfer(
    router.currentRoute.value.params.selectedTransferId
  );
}, null);

// const changeStyle = () => {
//   GlobalData.getInstance().changeSipPosition("border-start", "sip-layout");
// };
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  padding: 16px;
  padding-bottom: 0;
  min-width: 100%;
  overflow: auto;
}
</style>
